<template>
  <vs-popup id="popupSearchCompany" :title="title" :active.sync="showPopup" style="z-index: 53001">
    <div class="flex flex-col md:flex-row justify-between gap-y-4 shadow rounded-lg p-6 mb-6" style="border-bottom: 1px solid #e0e0e0">
      <div class="flex items-center">
        <p class="search-label" style="width: 80px">검색어</p>
        <ml-input ref="inputKeyword" v-model="search.keyword" @keyup.enter="handleClickSearch" class="w-full md:w-auto" />
      </div>
      <div>
        <vs-button color="secondary" type="border" @click="handleClearSearch" :disabled="!search.appliedKeyword" class="mr-1">초기화</vs-button>
        <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
      </div>
    </div>

    <vs-row>
      <vs-col style="max-height: 600px; overflow-y: auto">
        <vs-table stripe ref="table" :sst="true" :max-items="page.perPage" :data="companyList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail" @dblSelection="onCompanySelected">
          <template slot="thead">
            <vs-th class="">No.</vs-th>
            <vs-th class="">부서코드</vs-th>
            <vs-th class="">부서명</vs-th>
            <vs-th class="">전체 부서명</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :class="selectedCompany.id === company.id ? 'active' : ''" :data="company" :key="index" v-for="(company, index) in data">
              <vs-td>{{ (page.loadedPage - 1) * page.perPage + index + 1 }}</vs-td>
              <vs-td>{{ company.code }}</vs-td>
              <vs-td>{{ company.com_name }}</vs-td>
              <vs-td>{{ company.full_name ? company.full_name.join(" > ") : ""}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="onCompanySelected" :disabled="!selectedCompany.id">선택</vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "PopupSearchVirtualCompany",
  props: {
    value: Boolean,
    selectId: [String, Number],
    fieldId: {
      type: Number | null,
      default: null,
    },
    title: {
      type: String,
      default: "부서 검색",
    },
  },
  emits: ["input", "handleClickClose", "on-company-selected"],
  components: { KPagination },

  watch: {
    value(data) {
      this.showPopup = data;
      if (this.oldSelectedCompany.id) {
        this.selectedCompany = this.oldSelectedCompany;
      }
    },
    selectId(id) {
      this.oldSelectedCompanyId = id;
      if (this.companyList) {
        for (const company of this.companyList) {
          if (company.id === this.oldSelectedCompanyId) {
            try {
              this.oldSelectedCompany = company;
              this.selectedCompany = company;
            } catch (e) {}
            break;
          }
        }
      }
    },
    showPopup(data) {
      this.$emit("input", data);
      this.selectedCompany = this.oldSelectedCompany;

      // 팝업이 열릴 때 목록을 조회한다.
      // (이전에는 k-pagination 이 mount 되며 발생시키는 change 이벤트에 의존했기 때문에,
      //  팝업이 닫혀있어도 목록 API 가 호출되었다)
      if (data) {
        this.page.current = 1;
        this.loadCompanyList();
      }
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      showPopup: false,

      oldSelectedCompanyId: 0,
      oldSelectedCompany: {},
      selectedCompany: {},

      companyList : [],

      // 페이징
      page: {
        current: 1,
        loadedPage: 1,
        lastPage: 1,
        perPage: 10,
        total: 0,
      },

      // 겅색
      search: {
        keyword: "", // 입력된 검색어
        appliedKeyword: "", // 적용된 검색어
      },
    };
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  created() {
    this.showPopup = this.value;
    this.oldSelectedCompanyId = this.selectId;
  },

  methods: {
    async loadCompanyList() {
      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.search.appliedKeyword;
      const projectId = this.projectId;

      let params = { page, perPage, keyword, projectId };
      if (this.fieldId) params = { ...params, fieldId: this.fieldId };

      const result = await this.$store.dispatch("company/LOAD_VIRTUAL_COMPANY_LIST", params);
      this.companyList = result.data ? result.data : [];
      this.page.loadedPage = result.current_page;
      this.page.lastPage = result.last_page;
      this.page.total = result.total;
    },

    handleClickClose() {
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleClickSearch() {
      this.page.current = 1;
      this.search.appliedKeyword = this.search.keyword;
      this.loadCompanyList();
    },
    handleClearSearch() {
      this.search.keyword = "";
      this.search.appliedKeyword = "";
      this.page.current = 1;
      this.loadCompanyList();
    },

    handleChangePage(page) {
      // 팝업이 닫혀있는 동안에는 조회하지 않는다.
      // (vs-popup 은 닫혀있어도 슬롯을 렌더링하므로, k-pagination 이 mount 되며 change 이벤트를 발생시킨다)
      if (!this.showPopup) {
        return;
      }
      this.page.current = page;
      this.loadCompanyList();
    },

    handleItemClickDetail(data) {
      if (this.selectedCompany === data) {
        this.selectedCompany = {};
      } else {
        this.selectedCompany = data;
      }
    },

    onCompanySelected(data) {
      // 리스트에서 더블클릭됐을 때는 아이템 데이터가 전달된다
      if (data && data.id && data.code) {
        this.handleItemClickDetail(data);
      }

      this.$emit("input", false);
      this.$emit("on-company-selected", this.selectedCompany);
    },
  },
};
</script>

<style lang="scss" scoped>
#popupSearchCompany::v-deep .vs-popup {
  width: 90% !important;
  @media print, screen and (min-width: theme("screens.xl")) {
    width: 1200px !important;
  }

  .vs-con-table.stripe .tr-values.active {
    background: rgb(102, 112, 203) !important;
    color: #fff;
    font-width: bold;
  }
}
</style>
